var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-play sm2-play",on:{"click":function($event){return _vm.clickAudioPlayButton()}}},[_c('i',{staticClass:"fas fa-fw",class:_vm.classPlayStatus})])])}
var staticRenderFns = []

export { render, staticRenderFns }